let interval;

const redirect = () => {
    interval = setInterval(decrement, 1000);
}

const decrement = () => {
    const element = document.getElementById("time-remaining");
    if (!element) return;

    const text = Number.parseInt(element.innerText);
    const newNumber = text - 1;
    element.innerText = newNumber;

    if (newNumber <= 0) {
        clearInterval(interval);
        const anchor = document.getElementById("redirect");
        window.location.href = anchor.href;
    }
}

document.addEventListener("DOMContentLoaded", redirect);